(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kenzie-amazon-favorites"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (section.dataset.amazonInitialized === 'true') return;
      section.dataset.amazonInitialized = 'true';

      const grid = section.querySelector('[data-amazon-grid]');
      if (!grid) return;

      const cards = [...grid.querySelectorAll('[data-amazon-card]')];
      const search = section.querySelector('[data-amazon-search]');
      const filters = section.querySelector('[data-amazon-filters]');
      const noResults = section.querySelector('[data-amazon-no-results]');
      const categories = new Map();
      let activeCategory = 'all';

      cards
        .sort((left, right) => Number(left.dataset.sort) - Number(right.dataset.sort))
        .forEach((card) => {
          grid.append(card);
          categories.set(card.dataset.category, card.dataset.categoryLabel);
        });

      const addFilter = (value, label, active = false) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kenzie-amazon__filter';
        button.dataset.category = value;
        button.textContent = label;
        button.setAttribute('aria-pressed', String(active));
        filters.append(button);
      };

      const categoryEntries = [...categories.entries()]
        .sort((left, right) => left[1].localeCompare(right[1]));

      if (categoryEntries.length > 1) {
        addFilter('all', filters.dataset.allLabel, true);
        categoryEntries.forEach(([value, label]) => addFilter(value, label));
      } else {
        filters.hidden = true;
      }

      const applyFilters = () => {
        const query = search?.value.trim().toLowerCase() || '';
        let visible = 0;

        cards.forEach((card) => {
          const categoryMatches = activeCategory === 'all' || card.dataset.category === activeCategory;
          const searchMatches = !query
            || card.dataset.title.includes(query)
            || card.dataset.categoryLabel.toLowerCase().includes(query);
          const show = categoryMatches && searchMatches;
          card.hidden = !show;
          if (show) visible += 1;
        });

        noResults.hidden = visible !== 0;
      };

      filters.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-category]');
        if (!button) return;
        activeCategory = button.dataset.category;
        filters.querySelectorAll('button').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        applyFilters();
      });

      search?.addEventListener('input', applyFilters);

      section.addEventListener('click', (event) => {
        const link = event.target.closest('[data-amazon-product-link]');
        if (!link || window.Shopify?.designMode) return;
        if (typeof window.Shopify?.analytics?.publish !== 'function') return;

        try {
          const card = link.closest('[data-amazon-card]');
          const published = window.Shopify.analytics.publish('kenzie:affiliate_product_click', {
            affiliate_network: 'amazon',
            asin: link.dataset.asin,
            category: card?.dataset.categoryLabel || '',
            product_name: card?.querySelector('h2')?.textContent.trim().slice(0, 100) || '',
            page_path: window.location.pathname,
          });
          Promise.resolve(published).catch(() => {});
        } catch {
          return;
        }
      });
    };

    document.querySelectorAll('[data-amazon-favorites]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-amazon-favorites]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kenzie-amazon-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (section.dataset.amazonVideosInitialized === 'true') return;
      section.dataset.amazonVideosInitialized = 'true';

      const list = section.querySelector('[data-amazon-video-list]');
      if (list) {
        [...list.querySelectorAll('[data-amazon-video]')]
          .sort((left, right) => Number(left.dataset.sort) - Number(right.dataset.sort))
          .forEach((item) => list.append(item));
      }

      section.addEventListener('click', (event) => {
        if (window.Shopify?.designMode) return;
        if (typeof window.Shopify?.analytics?.publish !== 'function') return;

        const video = event.target.closest('[data-amazon-video]');
        if (!video) return;

        try {
          const videoLink = event.target.closest('[data-amazon-video-link]');
          const productLink = event.target.closest('[data-amazon-product-link]');

          if (videoLink) {
            const published = window.Shopify.analytics.publish('kenzie:affiliate_video_click', {
              affiliate_network: 'amazon',
              video_id: video.dataset.videoId,
              video_name: video.querySelector('h2')?.textContent.trim().slice(0, 100) || '',
              page_path: window.location.pathname,
            });
            Promise.resolve(published).catch(() => {});
          }

          if (productLink) {
            const published = window.Shopify.analytics.publish('kenzie:affiliate_product_click', {
              affiliate_network: 'amazon',
              asin: productLink.dataset.asin,
              category: 'Amazon video',
              product_name: productLink.querySelector('.kenzie-amazon-videos__product-copy > span')?.textContent.trim().slice(0, 100) || '',
              source_video_id: video.dataset.videoId,
              page_path: window.location.pathname,
            });
            Promise.resolve(published).catch(() => {});
          }
        } catch {
          return;
        }
      });
    };

    document.querySelectorAll('[data-amazon-videos]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-amazon-videos]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kenzie-bio-links"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const trackLink = (event) => {
      if (event.type === 'auxclick' && event.button !== 1) return;
      if (window.Shopify?.designMode) return;
      const link = event.target.closest?.('.kenzie-bio__link, .kenzie-bio__social');
      if (!link || typeof window.Shopify?.analytics?.publish !== 'function') return;

      try {
        const destination = new URL(link.href, window.location.href);
        if (!['https:', 'http:', 'mailto:', 'tel:'].includes(destination.protocol)) return;
        const parameters = new URLSearchParams(window.location.search);
        const source = parameters.get('utm_source')?.toLowerCase();
        const knownSources = ['tiktok', 'instagram', 'youtube', 'facebook'];
        const label = link.querySelector('.kenzie-bio__label')?.textContent.trim()
          || link.getAttribute('aria-label') || 'Link';
        const isWebLink = ['https:', 'http:'].includes(destination.protocol);
        const published = window.Shopify.analytics.publish('kenzie:link_page_click', {
          link_name: label.slice(0, 100),
          link_type: link.classList.contains('kenzie-bio__social') ? 'social' : 'button',
          destination_host: isWebLink ? destination.hostname : destination.protocol.slice(0, -1),
          destination_path: isWebLink ? destination.pathname : '',
          outbound: destination.origin !== window.location.origin,
          page_path: window.location.pathname,
          social_source: knownSources.includes(source) ? source : 'unattributed',
        });
        Promise.resolve(published).catch(() => {});
      } catch {
        return;
      }
    };

    document.addEventListener('click', trackLink);
    document.addEventListener('auxclick', trackLink);
  })();

  } catch(e) { console.error(e); }
})();
})();
